import * as envConfig from '../common/apiConfig';

// Fetch config from html and make it available throughout the app;
const config = JSON.parse(document.getElementById('__CONFIG__').textContent);
envConfig.setConfig(config);
// __webpack_public_path__ is used to set a baseUrl when fetching dynamic imports in a 'production' build
// eslint-disable-next-line no-undef
__webpack_public_path__ = `${config.bundle_location}`;
